import { useErrorBoundary } from 'react-error-boundary';

import NameForm from 'components/MessageExtensions/NameForm';
import RatingContactFollowUpChallenge from 'components/MessageExtensions/RatingContactFollowUp/Challenge';
import RatingContactFollowUp from 'components/MessageExtensions/RatingContactFollowUp';
import RatingRequest from 'components/MessageExtensions/RatingRequest';
import FeedbackRequestForm from 'components/MessageExtensions/FeedbackRequestForm';
import { StaticError } from 'components/ErrorBoundary';

import { FormMessageProps } from 'components/MessageExtensions/types';
import { FORM_TEMPLATE_TYPES } from 'constants/form';
import QuestionFormTextOnly from 'components/MessageExtensions/RatingContactFollowUp/QuestionFormTextOnly';
import ContactFollowUpChatOnly from 'components/MessageExtensions/RatingContactFollowUp/ChatOnly';

/**
 * Given a form extension object, render the appropriate form message component
 */
export const FormMessage = (props: FormMessageProps) => {
  const { templateType } = props.form ?? {};
  const { showBoundary } = useErrorBoundary();

  if (!Object.values(FORM_TEMPLATE_TYPES).includes(templateType)) {
    const err = new StaticError(
      `Unknown/incompatible FORM_TEMPLATE_TYPE encountered: ${templateType}`,
    );
    showBoundary(err);
    return null;
  }

  const forms = {
    [FORM_TEMPLATE_TYPES.GATED_FLOW_NAME]: <NameForm {...props} />,
    [FORM_TEMPLATE_TYPES.RATING_REQUEST]: <RatingRequest {...props} />,
    [FORM_TEMPLATE_TYPES.RATING_CONTACT_FOLLOW_UP_CHALLENGE]: (
      <RatingContactFollowUpChallenge {...props} />
    ),
    [FORM_TEMPLATE_TYPES.RATING_CONTACT_FOLLOW_UP_TEXT_ONLY]: <QuestionFormTextOnly {...props} />,
    [FORM_TEMPLATE_TYPES.RATING_CONTACT_FOLLOW_UP]: <RatingContactFollowUp {...props} />,
    [FORM_TEMPLATE_TYPES.FEEDBACK_REQUEST]: <FeedbackRequestForm {...props} />,
    [FORM_TEMPLATE_TYPES.CONTACT_FOLLOW_UP_CHAT_ONLY]: <ContactFollowUpChatOnly {...props} />,
  };

  return forms[templateType];
};
